import { render, staticRenderFns } from "./IconCategory.vue?vue&type=template&id=7f21e6ee&scoped=true&"
import script from "./IconCategory.vue?vue&type=script&lang=js&"
export * from "./IconCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21e6ee",
  null
  
)

export default component.exports